export default __webpack_public_path__ + "static/media/2.54e869c1.png";